import collectionSerializer from '@shared/js/serializers/collectionSerializer.js'
import { store } from '@stores'
import { computed } from 'vue'
import {
  KEYS_FEATURED_COLLECTIONS,
  KEYS_COLLECTIONS,
} from '@config/storeKeys.js'

const {
  deleteStoreArrayData,
  addToStoreData,
  updateStore,
  generateId,
  getStore,
} = store()

export default function () {
  function addCollections(gameNameId, collections, query) {
    updateStore(generateId(KEYS_COLLECTIONS, gameNameId), {
      ...collectionSerializer.transform(collections),
      query,
    })
  }

  function getCollections(gameNameId) {
    return getStore(generateId(KEYS_COLLECTIONS, gameNameId))
  }

  function addCollection(gameNameId, collection) {
    const _collection = collectionSerializer.transform(collection)
    addToStoreData(generateId(KEYS_COLLECTIONS, gameNameId), _collection)
    return _collection
  }

  function getCollectionId(collectionNameId, gameNameId) {
    collectionNameId = collectionNameId?.toLowerCase()
    const collections = getCollections(gameNameId)
    const collection = collections.value?.data?.find(
      (g) => g.name_id.toLowerCase() === collectionNameId
    )
    return collection ? collection.id : null
  }

  function getCollectionByNameId(gameNameId, collectionNameId) {
    const collections = getCollections(gameNameId)
    collectionNameId = collectionNameId?.toLowerCase()

    return computed(() =>
      collections.value?.data?.find(
        (collection) => collection.name_id.toLowerCase() === collectionNameId
      )
    )
  }

  function removeCollections(gameNameId) {
    updateStore(generateId(KEYS_COLLECTIONS, gameNameId))
  }

  function removeCollection(gameNameId, collectionNameId) {
    deleteStoreArrayData(
      generateId(KEYS_COLLECTIONS, gameNameId),
      (collection) => collection.name_id === collectionNameId
    )
  }

  function getFeaturedCollections(gameNameId, carouselId) {
    return getStore(
      generateId(KEYS_FEATURED_COLLECTIONS, gameNameId, carouselId)
    )
  }

  function addFeaturedCollections(gameNameId, carouselId, collections, query) {
    updateStore(generateId(KEYS_FEATURED_COLLECTIONS, gameNameId, carouselId), {
      ...collectionSerializer.transform(collections),
      query,
    })
  }

  return {
    addFeaturedCollections,
    getFeaturedCollections,
    getCollectionByNameId,
    removeCollections,
    removeCollection,
    getCollectionId,
    addCollections,
    getCollections,
    addCollection,
  }
}
